import { Grid } from '@material-ui/core';
import Tab from 'components/common/tabs/Tab';
import TabBar from 'components/common/tabs/TabBar';
import TabContainer from 'components/common/tabs/TabContainer';
import { PropsWithChildren } from 'react';
import * as React from 'react';
import { TabInfo } from 'types/common/tabs';

interface Props<T = TabInfo> {
  selectedTab?: T;
  onChange?: (tab: T) => void;
  tabs: TabInfo[];
}

const TabLayout = <T extends unknown>({
  children,
  tabs,
  selectedTab,
  onChange,
}: PropsWithChildren<Props<T>>) => {
  return (
    <TabContainer selectedTab={selectedTab}>
      <Grid container justify="space-between">
        <Grid item>
          <TabBar selectedValue={selectedTab} onChange={onChange}>
            {tabs.map((tabProps, index) => (
              <Tab key={index} {...tabProps} />
            ))}
          </TabBar>
        </Grid>
      </Grid>
      {children}
    </TabContainer>
  );
};

export default TabLayout;
